module.exports = __webpack_public_path__ + "img/belfius.23c867be.svg";